import script from "./PurchaseForm.vue?vue&type=script&setup=true&lang=js"
export * from "./PurchaseForm.vue?vue&type=script&setup=true&lang=js"

import "./PurchaseForm.vue?vue&type=style&index=0&id=278eb814&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-278eb814"]])

export default __exports__